export function MySQLMigrationsPage() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <h1 className="text-4xl font-bold">Migrations - MySQL Template</h1>
        <p className="text-lg text-muted-foreground max-w-4xl leading-relaxed">
          Learn how to manage database schema changes with TypeORM migrations.
        </p>
      </div>

      <div className="space-y-6">
        <h2 className="text-2xl font-bold">What are Migrations?</h2>
        <p className="text-muted-foreground leading-relaxed">
          Migrations are version control for your database schema. They allow you to modify your database 
          schema over time in a structured and tracked way.
        </p>
      </div>

      <div className="space-y-6">
        <h2 className="text-2xl font-bold">Available Commands</h2>
        
        <div className="space-y-4">
          <CommandCard
            title="Run Migrations"
            command="npm run migration:run"
            description="Executes all pending migrations"
          />
          <CommandCard
            title="Revert Last Migration"
            command="npm run migration:revert"
            description="Reverts the most recently executed migration"
          />
          <CommandCard
            title="Generate Migration"
            command="npm run migration:generate -- -n MigrationName"
            description="Generates a new migration based on entity changes"
          />
          <CommandCard
            title="Create Empty Migration"
            command="npm run migration:create -- -n MigrationName"
            description="Creates a new empty migration file"
          />
          <CommandCard
            title="Show Migrations"
            command="npm run migration:show"
            description="Shows all migrations and their status"
          />
        </div>
      </div>

      <div className="bg-muted/30 rounded-xl p-8 space-y-6">
        <h2 className="text-2xl font-bold">Migration Example</h2>
        <pre className="bg-muted p-6 rounded-lg overflow-x-auto text-sm">
          <code>{`import { MigrationInterface, QueryRunner } from "typeorm";

export class InitialSchema1735000000000 implements MigrationInterface {
    name = 'InitialSchema1735000000000'

    public async up(queryRunner: QueryRunner): Promise<void> {
        await queryRunner.query(\`
            CREATE TABLE \\\`users\\\` (
                \\\`id\\\` varchar(36) NOT NULL,
                \\\`email\\\` varchar(255) NOT NULL,
                \\\`password\\\` varchar(255) NOT NULL,
                \\\`firstName\\\` varchar(255) NOT NULL,
                \\\`lastName\\\` varchar(255) NOT NULL,
                \\\`role\\\` enum ('USER', 'ADMIN', 'SUPER_ADMIN') NOT NULL DEFAULT 'USER',
                \\\`createdAt\\\` datetime(6) NOT NULL DEFAULT CURRENT_TIMESTAMP(6),
                \\\`updatedAt\\\` datetime(6) NOT NULL DEFAULT CURRENT_TIMESTAMP(6) ON UPDATE CURRENT_TIMESTAMP(6),
                UNIQUE INDEX \\\`IDX_USER_EMAIL\\\` (\\\`email\\\`),
                PRIMARY KEY (\\\`id\\\`)
            ) ENGINE=InnoDB
        \\\`);
    }

    public async down(queryRunner: QueryRunner): Promise<void> {
        await queryRunner.query(\`DROP TABLE \\\`users\\\`\`);
    }
}`}</code>
        </pre>
      </div>

      <div className="bg-primary/5 border-l-4 border-primary rounded-r-lg p-6">
        <p className="text-sm font-semibold mb-2">💡 Best Practices</p>
        <ul className="space-y-2 text-sm">
          <li>• Always test migrations in development before running in production</li>
          <li>• Keep migrations small and focused on a single change</li>
          <li>• Never modify existing migrations that have been deployed</li>
          <li>• Always provide both up() and down() methods</li>
          <li>• Use descriptive names for migrations</li>
        </ul>
      </div>
    </div>
  )
}

function CommandCard({ title, command, description }: { title: string, command: string, description: string }) {
  return (
    <div className="bg-card border rounded-lg p-4 space-y-2">
      <h3 className="font-semibold">{title}</h3>
      <pre className="bg-muted p-3 rounded text-sm overflow-x-auto">
        <code>{command}</code>
      </pre>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  )
}

